<template>
  <nav :class="$style.navigation">
    <router-link
      v-for="(option, idx) in options"
      :key="idx"
      v-slot="{ navigate, isActive }"
      :to="{ name: option.href }"
      custom
    >
      <card-navigation
        :option="option"
        :active="isActive"
        @click="navigate"
      />
    </router-link>
  </nav>
</template>

<script>
import CardNavigation from 'molecules/navigation/CardNavigation';

import { NAVIGATION_LIST } from 'definitions/streamer/widgets';

export default {
  name: 'NavigationController',
  components: {
    CardNavigation,
  },
  data() {
    return {
      options: NAVIGATION_LIST,
    };
  },
};
</script>

<style lang="sass" module>
  .navigation
    width: 100%
    display: grid
    grid-gap: 20px
    grid-template-rows: 1fr 1fr
    grid-template-columns: 1fr 1fr

    +respond-to('medium')
      grid-template-rows: 1fr
      grid-template-columns: 1fr 1fr 1fr 1fr
</style>
